import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SalaryService {

  constructor(private http: HttpClient) { }


  GetRecord(Token: String, year: number): Observable<Array<any>> {
    return this.http.get(environment.BaseUrl + "Daro/Salary?token=" + Token
      + "&year=" + year).pipe(
        map(data => {
          return data as Array<any>
        })
      )
  }

  GetSingle(Token: String, year: number): Observable<Array<any>> {
    return this.http.get(environment.BaseUrl + "Daro/Salary/GetSingle?token=" + Token
      + "&year=" + year).pipe(
        map(data => {
          return data as Array<any>
        })
      )
  }

  GetSinglePerson(Token: String, year: number, personId: number): Observable<Array<any>> {
    return this.http.get(environment.BaseUrl + "Daro/Salary/GetSinglePerson?token=" + Token
      + "&year=" + year + "&personId=" + personId).pipe(
        map(data => {
          return data as Array<any>
        })
      )
  }


  Add(model: any, Token: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      model: model,
      token: Token,
    }


    return this.http.post(environment.BaseUrl + "Daro/Salary/Add", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  AddPerson(model: any, Token: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      model: model,
      token: Token,
    }

    return this.http.post(environment.BaseUrl + "Daro/Salary/AddPerson", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }





  GetEzafekar(Token: String, year: number, month: number): Observable<Array<any>> {
    return this.http.get(environment.BaseUrl + "Daro/Salary/GetEzafekar?token=" + Token
      + "&year=" + year
      + "&month=" + month).pipe(
        map(data => {
          return data as Array<any>
        })
      )
  }

  AddEzafekar(model: any, Token: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      model: model,
      token: Token,
    }

    return this.http.post(environment.BaseUrl + "Daro/Salary/AddEzafekar", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }



  GetDay(Token: String, year: number, month: number): Observable<Array<any>> {
    return this.http.get(environment.BaseUrl + "Daro/Salary/GetDay?token=" + Token
      + "&year=" + year
      + "&month=" + month).pipe(
        map(data => {
          return data as Array<any>
        })
      )
  }

  AddDay(model: any, Token: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      model: model,
      token: Token,
    }


    return this.http.post(environment.BaseUrl + "Daro/Salary/AddDay", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }



  GetSalaryMonth(Token: String, year: number, month: number): Observable<Array<any>> {
    return this.http.get(environment.BaseUrl + "Daro/Salary/GetSalaryMonth?token=" + Token
      + "&month=" + month
      + "&year=" + year).pipe(
        map(data => {
          return data as Array<any>
        })
      )
  }


  GetSalaryMonthFish(Token: String, year: number, month: number, id: number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Salary/GetSalaryMonthFish?token=" + Token
      + "&month=" + month
      + "&id=" + id
      + "&year=" + year).pipe(
        map(data => {
          return data as any
        })
      )
  }




  GetSanavat(Token: String, year: number): Observable<Array<any>> {
    return this.http.get(environment.BaseUrl + "Daro/Salary/GetSanavat?token=" + Token
      + "&year=" + year).pipe(
        map(data => {
          return data as Array<any>
        })
      )
  }

  AddSanavat(model: any, Token: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      model: model,
      token: Token,
    }


    return this.http.post(environment.BaseUrl + "Daro/Salary/AddSanavat", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

}
